import { Flex, Stack, Text, useCheckboxState } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { CollapsibleCheckbox } from '../../../CollapsibleCheckbox'
import { IntegerInput } from '../../../IntegerInput'
import { RestrictionsRegister } from './Component.register'
import styles from './styles.css'
import {
  RestrictionElementProps,
  RestrictionFieldProps,
} from '../hooks/useRestrictions.constate'

export const MaxUsage = (props: RestrictionFieldProps) =>
  RestrictionsRegister({ Element: MaxUsageEditor, props })

const MIN_VALUE = 1

function MaxUsageEditor(props: RestrictionElementProps) {
  const { name, form } = props

  const { $t } = useIntl()

  const maxUsage: boolean = useWatch({
    form,
    name,
  })

  const handleChange = ({ target: { checked } }) => {
    if (!checked) {
      form.resetField(name)
      form.setValue(name, undefined)
    } else {
      form.setValue(name, MIN_VALUE)
    }
  }

  const state = useCheckboxState({ initialValue: maxUsage !== undefined })

  return (
    <Stack fluid space="$space-4">
      <CollapsibleCheckbox
        state={state}
        label={$t({
          id: 'admin/promotions.form.restrictions.max-usage',
        })}
        onChange={handleChange}
      >
        <Flex align="baseline">
          <div className={styles.inputContainer}>
            <IntegerInput
              name={name}
              state={form}
              min={MIN_VALUE}
              aria-label={$t({
                id: 'admin/promotions.form.restrictions.max-usage.input.aria-label',
              })}
            />
          </div>

          <Text tone="secondary">
            {$t(
              { id: 'admin/promotions.form.utils.times' },
              { value: maxUsage }
            )}
          </Text>
        </Flex>
      </CollapsibleCheckbox>
    </Stack>
  )
}
